export function swapListingReference(value) {
  const raw = String(value ?? '')
  return !Array.isArray(value) && /^[1-9]\d*$/.test(raw) && Number.isSafeInteger(Number(raw)) ? raw : ''
}

export function swapListingSharePath(listing) {
  const id = swapListingReference(listing?.id)
  const event = listing?.event_slug || listing?.event
  if (!id || !event || listing.status !== 'approved') return ''
  return `/event/${encodeURIComponent(event)}/?swap_listing=${id}`
}
